var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.reportData
    ? _c(
        "div",
        { staticClass: "wx-chronic" },
        [
          _c("wxchronicheader", {
            attrs: {
              type: _vm.reportData.type_attention,
              healthStatus: _vm.reportData.health_status,
              displayId: _vm.reportData.display_id,
              time: _vm.reportData.time,
              symptoms: _vm.reportData.symptoms,
              isInclination: _vm.reportData.is_inclination
            }
          }),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("wxinfo", {
                attrs: {
                  type: "female",
                  info: _vm.reportData.owner,
                  age: _vm.reportData.user_info.ages
                }
              }),
              _c("wxchronicchart", {
                attrs: {
                  symptoms: _vm.reportData.symptoms,
                  symptomStatus: _vm.reportData.symptom_status,
                  beforeSymptomStatus: _vm.reportData.before_symptom_status,
                  healthStatus: _vm.reportData.health_status,
                  typeAttention: _vm.reportData.type_attention
                }
              }),
              _c("wxexplan", {
                attrs: {
                  type: "chronic",
                  symptoms: _vm.reportData.symptoms,
                  symptomDefinition:
                    _vm.reportData.solutions.chronic_disease_definition
                }
              }),
              _c("wxfaceresult", {
                attrs: {
                  faceData: _vm.reportData.face_result,
                  facePhotoUrl: _vm.reportData.face_photo_url
                }
              }),
              _c("wxtongueresult", {
                attrs: {
                  tongueData: _vm.reportData.tongue_result,
                  tonguePhotoUrl: _vm.reportData.tongue_photo_url
                }
              }),
              _vm.reportData.pulse.length !== 0
                ? _c("wxpulseresult", {
                    attrs: { pulse: _vm.reportData.pulse }
                  })
                : _vm._e(),
              _vm.reportData.pulse.length !== 0 &&
              _vm.reportData.pulse[0].blood_dia !== 0 &&
              _vm.reportData.pulse[0].blood_sys !== 0
                ? _c("wxbloodpressure", {
                    attrs: { pulse: _vm.reportData.pulse }
                  })
                : _vm._e(),
              _c("wxchronicscheme", { attrs: { reportData: _vm.reportData } }),
              _c("div", { staticClass: "tip" }, [
                _vm._v("此报告仅作参考，如有不适请及时就医")
              ]),
              _vm.reportData.doctor.length !== 0
                ? _c("wxdoctorlist", {
                    attrs: { doctorData: _vm.reportData.doctor }
                  })
                : _vm._e(),
              _vm.reportData.product && _vm.reportData.product.length !== 0
                ? _c("wxproduct", {
                    attrs: { productData: _vm.reportData.product }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }